import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './SurveyCallInformation.css';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import FormLabel from '@mui/material/FormLabel';
import Box from '@mui/material/Box';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

const Item = styled(Paper)(({ theme }) => ({
  boxShadow: 'none',
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary
}));

const styles = {
  inputLabelStyle: {
    color: '#929292',
    textAlign: 'left',
    paddingLeft: '20px',
    paddingBottom: '10px',
    font: 'normal normal normal 14px/19px Open Sans',
    fontSize: 'large',
    fontWeight: '800'
  },
  radioLabelStyle: {
    color: '#929292',
    textAlign: 'left',
    paddingBottom: '10px',
    font: 'normal normal normal 14px/19px Open Sans',
    fontWeight: '800'
  }
};

const SurveyCallInformation = props => {
  const [error, setError] = useState(false);
  
  const nextClicked = e => {
  let errorFound = false;
    for (const val in props.generalDetails) {
      if (props.generalDetails[val] === '' && val !== 'claimOther') {
        errorFound = true;
        setError(true);
      }
    }

    if (!errorFound) {
      setError(false);
      props.next(e);
    }
  };

  const handleChange = event => {
    props.handleGeneralDetailsChange(event);
  };
  
  return (
    <div
      id="callInfoDiv"
      style={{
        display: 'flex',
        justiyContent: 'space-between',
        flexDirection: 'column'
      }}
    >
      <div id="pageTitle">
        <p className="surveyHeading">
          {props.contactAttributes.typeId === 'Chat'
            ? 'CHAT INFORMATION'
            : props.contactAttributes.typeId === 'Task'
            ? 'TASK INFORMATION'
            : 'CALL INFORMATION'}
        </p>
        <hr className="hr" />
      </div>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={6}>
          <Item>
            <InputLabel shrink htmlFor="first-name" sx={styles.inputLabelStyle} className="fs-unmask">
              Agent&apos;s First Name
            </InputLabel>
            <TextField
              id="first-name"
              name="firstName"
              variant="outlined"
              size="small"
              onChange={handleChange}
              value={props.generalDetails.firstName}
              required
              error={error && props.generalDetails.firstName === ''}
              helperText={
                error && props.generalDetails.firstName === '' ? 'Required' : ''
              }
              inputProps={{
                style: {
                  paddingLeft: '40px'
                }
              }}
              className="fs-unmask"
            />
          </Item>
        </Grid>
        <Grid item xs={6}>
          <Item>
            <InputLabel shrink htmlFor="last-name" sx={styles.inputLabelStyle} className="fs-unmask">
              Agent&apos;s Last Name
            </InputLabel>
            <TextField
              id="last-name"
              name="lastName"
              variant="outlined"
              size="small"
              onChange={handleChange}
              value={props.generalDetails.lastName}
              required
              error={error && props.generalDetails.lastName === ''}
              helperText={
                error && props.generalDetails.lastName === '' ? 'Required' : ''
              }
              inputProps={{
                style: {
                  paddingLeft: '40px'
                }
              }}
              className="fs-unmask"
            />
          </Item>
        </Grid>
        <Grid item xs={6}>
          <Item>
            <InputLabel shrink htmlFor="email" sx={styles.inputLabelStyle} className="fs-unmask">
              Agent&apos;s Email
            </InputLabel>
            <TextField
              id="email"
              name="email"
              variant="outlined"
              size="small"
              onChange={handleChange}
              value={props.generalDetails.email}
              required
              error={error && props.generalDetails.email === ''}
              helperText={
                error && props.generalDetails.email === '' ? 'Required' : ''
              }
              inputProps={{
                style: {
                  paddingLeft: '40px'
                }
              }}
              className="fs-unmask"
            />
          </Item>
        </Grid>
      </Grid>
      <Grid
        container
        rowSpacing={0}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        style={{ paddingBottom: '100px' }}
      >
        <Grid item xs={12}>
          <Item>
            <InputLabel
              shrink
              htmlFor="customerNumber"
              sx={styles.inputLabelStyle}
              className="fs-unmask"
            >
              Customer Number
            </InputLabel>
            <FormControl style={{ width: '95%' }}>
              <TextField
                id="customerNumber"
                name="customerNumber"
                variant="outlined"
                placeholder="Customer Number"
                size="small"
                required
                error={error && props.generalDetails.customerNumber === ''}
                helperText={
                  error && props.generalDetails.customerNumber === ''
                    ? 'Required'
                    : ''
                }
                onChange={handleChange}
                value={props.generalDetails.customerNumber}
                className="fs-unmask"
              />
              {error && props.generalDetails.customerNumber === '' ? (
                <FormHelperText>Required</FormHelperText>
              ) : null}
            </FormControl>
          </Item>
        </Grid>
        <Grid item xs={12}>
          <Item>
            <InputLabel shrink htmlFor="language" sx={styles.inputLabelStyle} className="fs-unmask">
              Language
            </InputLabel>
            <FormControl
              style={{ width: '95%', textAlign: 'left' }}
              size="small"
              error={error && props.generalDetails.language === ''}
            >
              <Select
                id="language"
                name="language"
                onChange={handleChange}
                value={props.generalDetails.language}
                displayEmpty
                required
                inputProps={{
                  'aria-label': 'Without label',
                  'text-align': 'left'
                }}
                className="fs-unmask"
              >
                <MenuItem value={'English'}>English</MenuItem>
                <MenuItem value={'Spanish'}>Spanish</MenuItem>
              </Select>
              {error && props.generalDetails.language === '' ? (
                <FormHelperText>Required</FormHelperText>
              ) : null}
            </FormControl>
          </Item>
          <Item>
            <InputLabel shrink htmlFor="language" sx={styles.inputLabelStyle} className="fs-unmask">
              Caller Type
            </InputLabel>
            <FormControl
              style={{ width: '95%', textAlign: 'left' }}
              size="small"
              error={error && props.generalDetails.callerType === ''}
            >
              <Select
                id="callerType"
                name="callerType"
                onChange={handleChange}
                value={props.generalDetails.callerType}
                displayEmpty
                required
                inputProps={{
                  'aria-label': 'Without label',
                  'text-align': 'left'
                }}
                className="fs-unmask"
              >
                {props.callerTypeOptions.map(option => {
                  return <MenuItem key={option} value={option}>{option}</MenuItem>;
                })}
              </Select>
              {error && props.generalDetails.language === '' ? (
                <FormHelperText>Required</FormHelperText>
              ) : null}
            </FormControl>
          </Item>
          <Item>
            <InputLabel
              shrink
              htmlFor="requestType"
              sx={styles.inputLabelStyle}
              className="fs-unmask"
            >
              Request Type
            </InputLabel>
            <FormControl
              style={{ width: '95%', textAlign: 'left' }}
              size="small"
              error={error && props.generalDetails.requestType === ''}
            >
              <Select
                id="requestType"
                name="requestType"
                onChange={handleChange}
                value={props.generalDetails.requestType}
                displayEmpty
                required
                inputProps={{ 'aria-label': 'Without label' }}
                className="fs-unmask"
              >
                {props.requestTypeOptions.map(option => {
                  return <MenuItem key={option} value={option}>{option}</MenuItem>;
                })}
              </Select>
              {error && props.generalDetails.requestType === '' ? (
                <FormHelperText>Required</FormHelperText>
              ) : null}
            </FormControl>
          </Item>
          <Item>
            <InputLabel shrink htmlFor="claims" sx={styles.inputLabelStyle} className="fs-unmask">
              Most recent claim ID
            </InputLabel>
            <FormControl
              style={{ width: '95%', textAlign: 'left' }}
              size="small"
              error={error && props.generalDetails.claim === ''}
            >
              {props.caseIds.length > 0 ? (
                <Select
                  id="claims"
                  name="claim"
                  onChange={handleChange}
                  value={props.generalDetails.claim}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                  className="fs-unmask"
                >
                  {props.caseIds.map(caseId => {
                    return <MenuItem key={caseId} value={caseId}>{caseId}</MenuItem>;
                  })}
                </Select>
              ) : (
                <TextField
                  id="claim"
                  name="claim"
                  variant="outlined"
                  placeholder="Claim/Leave ID"
                  size="small"
                  required
                  error={error && props.generalDetails.claim === ''}
                  helperText=""
                  onChange={handleChange}
                  value={props.generalDetails.claim}
                  className="fs-unmask"
                />
              )}
              {error && props.generalDetails.claim === '' ? (
                <FormHelperText>Required</FormHelperText>
              ) : null}
            </FormControl>
          </Item>
          {props.generalDetails.claim === 'Other' ? (
            <FormControl style={{ width: '93%', paddingLeft: '21px' }}>
              <TextField
                id="claimOther"
                name="claimOther"
                variant="outlined"
                placeholder="Other Claim"
                size="small"
                required
                error={error && props.generalDetails.claimOther === ''}
                helperText={'Please enter in the format NTN-1234-XXX-12 e.g. NTN-7268-GDC-01, NTN-5192-ABS-01'}
                onChange={handleChange}
                value={props.generalDetails.claimOther}
                className="fs-unmask"
              />
            </FormControl>
          ) : null}
          <Item>
            <InputLabel shrink htmlFor="workItem" sx={styles.inputLabelStyle} className="fs-unmask">
              Work Item Type
            </InputLabel>
            <FormControl
              style={{ width: '95%', textAlign: 'left' }}
              size="small"
              error={error && props.generalDetails.workItemType === ''}
            >
              <Select
                id="workItemType"
                name="workItemType"
                value={props.generalDetails.workItemType}
                onChange={handleChange}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                className="fs-unmask"
              >
                {props.workItemTypeOptions.map(option => {
                  return <MenuItem key={option} value={option}>{option}</MenuItem>;
                })}
              </Select>
              {error && props.generalDetails.workItemType === '' ? (
                <FormHelperText>Required</FormHelperText>
              ) : null}
            </FormControl>
          </Item>
          {props.generalDetails.workItemType === 'Other' ? (
            <FormControl style={{ width: '93%', paddingLeft: '21px' }}>
              <TextField
                id="workItemTypeOther"
                name="otherWorkItemType"
                variant="outlined"
                placeholder="Other Work Item Type"
                size="small"
                required
                error={error && props.generalDetails.lastName === ''}
                helperText={
                  error && props.generalDetails.lastName === ''
                    ? 'Required'
                    : ''
                }
                onChange={handleChange}
                value={props.generalDetails.otherWorkItemType}
                className="fs-unmask"
              />
            </FormControl>
          ) : (
            ''
          )}
          <FormControl sx={{ paddingLeft: '20px' }}>
            <FormLabel
              id="demo-row-radio-buttons-group-label"
              sx={styles.radioLabelStyle}
              className="fs-unmask"
            >
              First time customer has contacted Unum about issue?
            </FormLabel>
            <RadioGroup
              id="firstTimeIssue"
              name="firstTimeIssue"
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              defaultValue="Yes"
              onChange={handleChange}
              className="fs-unmask"
            >
              <Box
                sx={{
                  border: 1,
                  borderColor: 'divider',
                  paddingLeft: '10px',
                  borderRadius: '8px',
                  backgroundColor:
                    props.generalDetails.firstTimeIssue === 'Yes'
                      ? '#E9F0F6'
                      : ''
                }}
              >
                <FormControlLabel
                  value="Yes"
                  control={
                    <Radio
                      checked={props.generalDetails.firstTimeIssue === 'Yes'}
                    />
                  }
                  label="Yes"
                  className="fs-unmask"
                />
              </Box>
              <Box
                sx={{
                  border: 1,
                  borderColor: 'divider',
                  marginLeft: '30px',
                  paddingLeft: '10px',
                  borderRadius: '8px',
                  backgroundColor:
                    props.generalDetails.firstTimeIssue === 'No'
                      ? '#E9F0F6'
                      : ''
                }}
              >
                <FormControlLabel
                  value="No"
                  control={
                    <Radio
                      checked={props.generalDetails.firstTimeIssue === 'No'}
                    />
                  }
                  label="No"
                  className="fs-unmask"
                />
              </Box>
              <Box
                sx={{
                  border: 1,
                  borderColor: 'divider',
                  marginLeft: '30px',
                  paddingLeft: '10px',
                  borderRadius: '8px',
                  backgroundColor:
                    props.generalDetails.firstTimeIssue === 'Unknown'
                      ? '#E9F0F6'
                      : ''
                }}
              >
                <FormControlLabel
                  value="Unknown"
                  control={
                    <Radio
                      checked={
                        props.generalDetails.firstTimeIssue === 'Unknown'
                      }
                    />
                  }
                  label="Unknown"
                  className="fs-unmask"
                />
              </Box>
            </RadioGroup>
          </FormControl>
          <FormControl sx={{ paddingLeft: '20px' }}>
            <FormLabel id="liability-radio-label" sx={styles.radioLabelStyle} className="fs-unmask">
              Has the person received their initial liability decision?
            </FormLabel>
            <RadioGroup
              row
              id='name="liabilityDecisionReceived"'
              name="liabilityDecisionReceived"
              aria-labelledby="liability-radio-group"
              defaultValue="Yes"
              onChange={handleChange}
              className="fs-unmask"
            >
              <Box
                sx={{
                  border: 1,
                  borderColor: 'divider',
                  paddingLeft: '10px',
                  borderRadius: '8px',
                  backgroundColor:
                    props.generalDetails.liabilityDecisionReceived === 'Yes'
                      ? '#E9F0F6'
                      : ''
                }}
              >
                <FormControlLabel
                  value="Yes"
                  control={
                    <Radio
                      checked={
                        props.generalDetails.liabilityDecisionReceived === 'Yes'
                      }
                    />
                  }
                  label="Yes"
                  className="fs-unmask"
                />
              </Box>
              <Box
                sx={{
                  border: 1,
                  borderColor: 'divider',
                  marginLeft: '30px',
                  paddingLeft: '10px',
                  borderRadius: '8px',
                  backgroundColor:
                    props.generalDetails.liabilityDecisionReceived === 'No'
                      ? '#E9F0F6'
                      : ''
                }}
              >
                <FormControlLabel
                  value="No"
                  control={
                    <Radio
                      checked={
                        props.generalDetails.liabilityDecisionReceived === 'No'
                      }
                    />
                  }
                  label="No"
                  className="fs-unmask"
                />
              </Box>
              <Box
                sx={{
                  border: 1,
                  borderColor: 'divider',
                  marginLeft: '30px',
                  paddingLeft: '10px',
                  borderRadius: '8px',
                  backgroundColor:
                    props.generalDetails.liabilityDecisionReceived === 'Unknown'
                      ? '#E9F0F6'
                      : ''
                }}
              >
                <FormControlLabel
                  value="Unknown"
                  control={
                    <Radio
                      checked={
                        props.generalDetails.liabilityDecisionReceived === 'Unknown'
                      }
                    />
                  }
                  className="fs-unmask"
                  label="Unknown"
                />
              </Box>
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
      <div
        id="buttonContainer"
        style={{ background: 'white' }}
        className="surveyButtonContainer"
      >
        <hr className="hr" />
        <Button
          id="nextButton"
          variant="contained"
          style={{
            background: '#127CB7',
            borderRadius: '20px',
            opacity: 1,
            marginBottom: '10px',
            width: '80%',
            left: '10%'
          }}
          onClick={nextClicked}
          className="fs-unmask"
        >
          Next
        </Button>
      </div>
    </div>
  );
};

SurveyCallInformation.propTypes = {
  contactAttributes: PropTypes.shape({
    typeId: PropTypes.string,
  }).isRequired,
  generalDetails: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    customerNumber: PropTypes.string,
    language: PropTypes.string,
    callerType: PropTypes.string,
    requestType: PropTypes.string,
    claim: PropTypes.string,
    claimOther: PropTypes.string,
    workItemType: PropTypes.string,
    otherWorkItemType: PropTypes.string,
    firstTimeIssue: PropTypes.string,
    liabilityDecisionReceived: PropTypes.string,
  }).isRequired,
  handleGeneralDetailsChange: PropTypes.func.isRequired,
  next: PropTypes.func.isRequired,
  callerTypeOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  requestTypeOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  workItemTypeOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  caseIds: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SurveyCallInformation;
